/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Glad_Warm_Eagle_SoarInputs */

const en_glad_warm_eagle_soar = /** @type {(inputs: Glad_Warm_Eagle_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Results access granted`)
};

const de_glad_warm_eagle_soar = /** @type {(inputs: Glad_Warm_Eagle_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ergebnisse freigegeben!`)
};

/**
* | output |
* | --- |
* | "Results access granted" |
*
* @param {Glad_Warm_Eagle_SoarInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const glad_warm_eagle_soar = /** @type {((inputs?: Glad_Warm_Eagle_SoarInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Glad_Warm_Eagle_SoarInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_glad_warm_eagle_soar(inputs)
	return de_glad_warm_eagle_soar(inputs)
});